import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { BehaviorSubject, debounceTime, distinctUntilChanged, switchMap, of, filter } from 'rxjs';
import { RegistryItem, RegistryOfficeItem } from 'src/app/api/models';
import { RegistryOfficesService, RegistryService } from 'src/app/api/services';

@Component({
  selector: 'app-input-office-picker',
  templateUrl: './input-office-picker.component.html',
  styleUrls: ['./input-office-picker.component.scss'],
})
export class InputOfficePickerComponent {
  @Input() frmControl?: AbstractControl;
  _frmControl?: FormControl;
  filterOffices$ = new BehaviorSubject<string>('');
  @Input() offices?: RegistryOfficeItem[];
  @Input() readOnly: boolean = false;

  constructor(
    private registryService: RegistryService,
    private registryOfficeService: RegistryOfficesService
  ) {}

  ngOnInit() {
    this.filterOffices$
      .pipe(
        filter(query => !!query),
        debounceTime(300),

        switchMap(query => {
          if (query) {
            return this.registryOfficeService.officeControllerGetAll({
              limit: 10,
              skip: 0,
              query,
            });
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: res => {
          this.offices = res.data.list;
        },
      });
  }

  ngAfterViewInit() {
    this._frmControl = this.frmControl as FormControl;
  }
}
